var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textnav"},[_c('ul',{staticClass:"textnav__wrapper"},[(_vm.items)?_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"textnav__item"},[_c('router-link',{staticClass:"textnav__link",attrs:{"to":item.href || ''}},[_vm._v(" "+_vm._s(item.label)+" ")])],1)}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }